<template>
  <ProductDetailGroup id="product-size-picker">
    <ProductSizePickerNew
      :product="product"
      :variants="productVariants"
      :selected-variant="activeVariant"
      @select-size="handleSelectedSize"
    />
    <template v-if="enableSizekick">
      <ClientOnly>
        <div id="sizekickWidget" class="mt-4"></div>
      </ClientOnly>
      <div
        id="sizekickProductData"
        style="visibility: hidden"
        :data-productID="product.id.toString()"
        :data-name="productName"
        :data-brand="productBrand"
        :data-category="breadcrumbs[breadcrumbs.length - 1]?.value"
        :data-sizes="sizekickSizes"
        :data-cover="product.images[0]?.hash"
        :data-images="sizekickImages"
        :data-description="productLongDescription"
        :data-url="`${config.public.baseUrl}${route.fullPath}`"
      ></div>
    </template>
  </ProductDetailGroup>
</template>

<script setup lang="ts">
import type { BreadcrumbItem, Product, Variant } from '@scayle/storefront-nuxt'
import { useRuntimeConfig } from '#app/nuxt'
import { useRoute } from '#app/composables/router'
import useSizeDisplayData from '../../../../../composables/useSizeDisplayData'

const props = defineProps<{
  activeVariant: Variant | undefined
  enableSizekick: boolean
  product: Product
  productBrand: string
  productName: string
  productLongDescription: string
  productVariants: Variant[]
  breadcrumbs: BreadcrumbItem[]
  handleSelectedSize: (variant: Variant) => void
}>()

defineEmits(['size-picker:select'])

const config = useRuntimeConfig()
const { getSizeDisplayData } = useSizeDisplayData()
const route = useRoute()

const sizekickSizes = computed(() => {
  const sizes = props.productVariants.map(getSizeDisplayData)
  return JSON.stringify(sizes)
})

const sizekickImages = computed(() => {
  const hashes = props.product.images.map((img) => img.hash)
  return JSON.stringify(hashes)
})
</script>
